<script>
export default {

  props: {
    action: {},
    startedAction: {}
  },

  computed: {
    actionRequired() {
      return this.action.runtime_traits || this.action.requiredInputs().length > 0
    },


    links() {
      if (!this.startedAction.result) { return [] }
      let links = []

      for(let paramName in this.startedAction.result) {
        let value = this.startedAction.result[paramName]
        if (!value || !value.slice || value.slice(0, 4) != 'http') { continue }
        links.push({
          href: value,
          label: paramName,
          id: value
        })
      }
      return links

    }

  }

}
</script>

<template>

  <div class="columns is-fullwidth" v-if="startedAction">
    <div class="column is-11">
      <b-notification v-if="startedAction.error" type="is-danger" :closable="false">
        <pre style="white-space: normal; background: none; color: white">{{ startedAction.error }}</pre>
      </b-notification>
      <div v-else-if="!startedAction.isLoading">
        <pre style="max-width: 100%">{{ startedAction.result }}</pre>

        <div v-if="links.length > 0">
          <strong>Links:</strong>
          <ul>
            <li v-for="link in links" :key="link.id">
              <a :href="link.href" target="_blank">{{ link.label }}</a>
            </li>
          </ul>
        </div>

      </div>
    </div>
    <div class="column is-narrow is-relative">
      <b-loading :active="startedAction.isLoading" :is-full-page="false"></b-loading>
      <b-icon :icon="startedAction.error ? 'alert-circle-outline' : 'check'"></b-icon>
    </div>
  </div>

</template>

<style lang="scss">
</style>